import React, { useState, useEffect } from 'react';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import { Container, Row, Col, Form, Button, Table } from 'react-bootstrap';
import * as Picklist from "./../../Picklist";
import * as Common from "./../../Common";
import $ from "jquery";
import { useNavigate } from 'react-router-dom';
import Dialog from './../../Dialog';
import FaView from '../../FaView';
import AsyncSelect from 'react-select/async';
import { faT } from '@fortawesome/free-solid-svg-icons';

const Tran_fa_view = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [faViewLocation, setFaViewLocation] = useState(null);
    const [faViewType, setFaViewType] = useState("");
    const [faViewSrno, SetFaViewSrno] = useState("");
    const [locationCode, setLocationCode] = useState(0);
    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);
    const [faViewTypeOptions, setFaViewTypeOptions] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFaViewLocation(response);
                response != null && handleFaViewLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'FA_VIEW'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            Common.callApi(Common.apiFaViewLog, [sid, "getFaViewType"], result => {
                setFaViewTypeOptions(JSON.parse(result));
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleFaViewLocation = (value) => {
        setFaViewLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
    }

    const faViewList = () => {
        var i = 0, msg = [];
        if (faViewLocation === null || faViewSrno == "" || faViewType == "") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (faViewLocation === null ? " Location." : '');
            msg[i++] = (faViewSrno == "" ? "Srno." : '');
            msg[i++] = (faViewType == "" ? "Type." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            console.log("Get Fa View List!");
            setShowFaView(true);
            setFaViewObject({ location: locationCode, trannumber: faViewSrno, type: faViewType });
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Fa View</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions={false}
                                defaultOptions={false}
                                value={faViewLocation}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={Picklist.fetchLocationAllowedPicklist}
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleFaViewLocation}
                                isDisabled={branchDisable === "true"}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Type<span className="colorThemeRed">*</span></Form.Label>
                            <Form.Select value={faViewType} onChange={e => setFaViewType(e.target.value)}>
                                {
                                    faViewTypeOptions.map((item, index) => (
                                        <option value={item.tfd_type} key={index}>{item.tfd_type}</option>
                                    ))
                                }
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>SrNo<span className="colorThemeRed">*</span></Form.Label>
                            <Form.Control type='text' maxLength={10} value={faViewSrno} onChange={e => Common.validateNumValue(e.target.value, SetFaViewSrno)} />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Button style={{ marginTop: '33px' }} variant="outline-primary" className="buttonStyle" size="sm" onClick={faViewList}>List</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
        </>
    )
}

export default Tran_fa_view
